export const PRACTICE_STATUS = {
  NOT_STARTED: 'not_started',
  ASSIGNED: 'assigned',
  ENGAGED: 'engaged',
  PROFICIENT: 'proficient'
} as const;

export type PracticeStatus = typeof PRACTICE_STATUS[keyof typeof PRACTICE_STATUS];
